const common = {
  "nav.home": "Home",
  "nav.live": "Live TV",
  "nav.news": "News",
  "nav.programs": "Programs",
  "nav.videos": "Videos",
  "nav.schedule": "TV Schedule",
  "nav.entertainment": "Entertainment & Culture",
  "nav.sports": "Sports",
  "nav.photoStudio": "Photo Studio",
  "nav.production": "Production",
  "nav.gallery": "Gallery",
  "nav.about": "About L+TV",
  "nav.contact": "Contact",
  "nav.adverts": "Announcements",
  "nav.more": "More",
  "nav.watchLive": "WATCH LIVE",
  "nav.edea": "Edea, Cameroon",

  "footer.quickLinks": "Quick Links",
  "footer.departments": "Departments",
  "footer.socialMedia": "Social Media",
  "footer.legal": "Legal",
  "footer.privacy": "Privacy Policy",
  "footer.terms": "Terms & Conditions",
  "footer.cookies": "Cookie Policy",
  "footer.disclaimer": "Disclaimer",
  "footer.home": "Home",
  "footer.live": "Live TV",
  "footer.news": "News",
  "footer.programs": "Programs",
  "footer.videos": "Videos",
  "footer.gallery": "Gallery",
  "footer.schedule": "Schedule",
  "footer.about": "About",
  "footer.contact": "Contact",
  "footer.entertainment": "Entertainment & Culture",
  "footer.technical": "Technical & Broadcasting",
  "footer.photoStudio": "Photo Studio",
  "footer.production": "Production",
  "footer.allRightsReserved": "All Rights Reserved.",

  "lang.english": "English",
  "lang.french": "Français",
};

export default common;